import React, { FC, ReactElement } from 'react';

import classNames from 'classnames';

import Plus from '@ast/magma/components/icon/icons/Plus';

import { Button } from '@ast/magma/components/button';

import styles from './AddButton.pcss';

export interface AddButtonProps {
  readonly text: string;
  readonly isNoItems?: boolean;
  readonly addIcon?: ReactElement;
  readonly onClick?: () => void;
}

export const AddButton: FC<AddButtonProps> = ({
  text,
  isNoItems,
  addIcon,
  onClick,
}) => {
  const noItems = isNoItems || false;
  return (
    <div className={classNames(noItems && styles.addButtonContainer, !noItems && styles.addButtonContainerWithItems)}>
      <Button
        look="outlined"
        icon={addIcon || <Plus />}
        predefinedSize="medium"
        className={classNames(styles.addButton)}
        data-stable-name="AddButton"
        onClick={onClick}
      >
        {text}
      </Button>
    </div>
  );
};
